import { calcRemFromPx } from "../../theme/util";

export const NAV_DRAWER_WIDTH = `${calcRemFromPx(263)}rem`;
